import apiClient from "../apiClient";
import { CommonApiResponse } from "../../Controllers/Types/ApiResponse";
import { baseURL } from "../ApiConstant";

// get type list
export const getFSTypeList = async (category: 'Tiles' | 'Light' | 'Floor Finishing') => {
    try {
        const formData = new FormData();
        formData.append("category", category);

        const response = await apiClient.post(`/api/fs-type-list`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });

        if (response.status === 200) {
            return { status: true, body: response.data };
        } else {
            return { status: false, error: "failed" };
        }
    } catch (error: any) {
        console.error("Error fetching data:", error);

        return {
            status: false,
            error: "An error occurred. Please try again later.",
        };
    }
};